export const profiles = [
  {
    id: "1",
    type: "user",
    rightSlot: "UserActions",
    bgColor: "#110e3f",
    overview: {
      name: "Zehra Ecer",
      firstName: "Zehra",
      lastName: "Ecer",
      email: "zehraecer96@gmail.com",
      role: "Admin",
      avatar: "https://i.pravatar.cc/160?img=30",
    },
    metrics: { openProjects: 2, projectsCompleted: 0, totalProjectHours: 5.5 },
    generalInfo: {
      mailingAddress: "zehraecer96@gmail.com",
      phone: { countryCode: "+90", nationalNumber: "5320000000" },
      skype: "zehra.ecer",
      dob: "1996-08-15",
      gender: "female",
    },
    jobInfo: {
      title: "Admin",
      manager: "Yönetici 1",
      salaryPeriod: "Aylık",
      startDate: "2023-01-01",
      endDate: null,
    },
    account: { email: "zehraecer96@gmail.com", role: "Admin" },
    preferences: { language: "English", webNotif: true },
    leave: { remainingDays: 14 },
  },
  {
    id: "2",
    type: "user",
    rightSlot: "UserActions",
    bgColor: "#110e3f",
    overview: {
      name: "Barış Korkmaz",
      firstName: "Barış",
      lastName: "Korkmaz",
      email: "baris.korkmaz@company.com",
      role: "HR Manager",
      avatar: "https://i.pravatar.cc/160?img=31",
    },
    metrics: { openProjects: 1, projectsCompleted: 4, totalProjectHours: 210 },
    generalInfo: {
      mailingAddress: "baris.korkmaz@company.com",
      phone: { countryCode: "+90", nationalNumber: "5311112233" },
      skype: "baris.hr",
      dob: "1989-04-12",
      gender: "male",
    },
    jobInfo: {
      title: "HR Manager",
      manager: "Zehra Ecer",
      salaryPeriod: "Aylık",
      startDate: "2022-05-01",
      endDate: null,
    },
    account: { email: "baris.korkmaz@company.com", role: "HR Manager" },
    preferences: { language: "Turkish", webNotif: true },
    leave: { remainingDays: 10 },
  },
  {
    id: "3",
    type: "user",
    rightSlot: "UserActions",
    bgColor: "#110e3f",
    overview: {
      name: "Elif Yıldız",
      firstName: "Elif",
      lastName: "Yıldız",
      email: "elif.yildiz@company.com",
      role: "UI/UX Designer",
      avatar: "https://i.pravatar.cc/160?img=45",
    },
    metrics: { openProjects: 3, projectsCompleted: 8, totalProjectHours: 420 },
    generalInfo: {
      mailingAddress: "elif.yildiz@company.com",
      phone: { countryCode: "+90", nationalNumber: "5554443322" },
      skype: "elif.design",
      dob: "1995-11-23",
      gender: "female",
    },
    jobInfo: {
      title: "UI/UX Designer",
      manager: "Zehra Ecer",
      salaryPeriod: "Aylık",
      startDate: "2021-09-15",
      endDate: null,
    },
    account: { email: "elif.yildiz@company.com", role: "Designer" },
    preferences: { language: "English", webNotif: true },
    leave: { remainingDays: 8 },
  },
  {
    id: "4",
    type: "client",
    companyName: "Acme Corp",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Acme Corp",
      firstName: "Acme",
      lastName: "Client",
      email: "contact@acme-corp.com",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=12",
    },
    metrics: { openProjects: 5, projectsCompleted: 12, totalProjectHours: 320 },
    generalInfo: {
      mailingAddress: "contact@acme-corp.com",
      phone: { countryCode: "+1", nationalNumber: "2125551212" },
      skype: "acme.support",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2024-01-10",
      endDate: null,
    },
    account: { email: "contact@acme-corp.com", role: "Client" },
    preferences: { language: "English", webNotif: true },
  },
  {
    id: "5",
    type: "client",
    companyName: "TechNova Solutions",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "TechNova Solutions",
      firstName: "TechNova",
      lastName: "Client",
      email: "info@technova.com",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=24",
    },
    metrics: { openProjects: 2, projectsCompleted: 5, totalProjectHours: 150 },
    generalInfo: {
      mailingAddress: "info@technova.com",
      phone: { countryCode: "+44", nationalNumber: "2075559090" },
      skype: "technova.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2023-06-05",
      endDate: null,
    },
    account: { email: "info@technova.com", role: "Client" },
    preferences: { language: "English", webNotif: false },
  },
  {
    id: "6",
    type: "client",
    companyName: "BlueWave Industries",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "BlueWave Industries",
      firstName: "BlueWave",
      lastName: "Client",
      email: "support@bluewave.com",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=36",
    },
    metrics: { openProjects: 3, projectsCompleted: 9, totalProjectHours: 220 },
    generalInfo: {
      mailingAddress: "support@bluewave.com",
      phone: { countryCode: "+49", nationalNumber: "3032129898" },
      skype: "bluewave.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2024-03-15",
      endDate: null,
    },
    account: { email: "support@bluewave.com", role: "Client" },
    preferences: { language: "German", webNotif: true },
  },
  {
    id: "7",
    type: "client",
    companyName: "NovaTrade Group",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "NovaTrade Group",
      firstName: "NovaTrade",
      lastName: "Client",
      email: "hello@novatradegroup.com",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=45",
    },
    metrics: { openProjects: 7, projectsCompleted: 20, totalProjectHours: 540 },
    generalInfo: {
      mailingAddress: "hello@novatradegroup.com",
      phone: { countryCode: "+33", nationalNumber: "145223344" },
      skype: "novatrade.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2022-09-21",
      endDate: null,
    },
    account: { email: "hello@novatradegroup.com", role: "Client" },
    preferences: { language: "French", webNotif: false },
  },
  {
    id: "8",
    type: "client",
    companyName: "Atlas Ventures",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "PixelForge Studios",
      firstName: "PixelForge",
      lastName: "Client",
      email: "contact@pixelforge.studio",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=52",
    },
    metrics: { openProjects: 4, projectsCompleted: 15, totalProjectHours: 410 },
    generalInfo: {
      mailingAddress: "contact@pixelforge.studio",
      phone: { countryCode: "+90", nationalNumber: "5327768899" },
      skype: "pixelforge.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2024-07-08",
      endDate: null,
    },
    account: { email: "contact@pixelforge.studio", role: "Client" },
    preferences: { language: "Turkish", webNotif: true },
  },
  {
    id: "9",
    type: "client",
    companyName: "Atlas Ventures",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Atlas Ventures",
      firstName: "Atlas",
      lastName: "Client",
      email: "team@atlasventures.io",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=58",
    },
    metrics: { openProjects: 6, projectsCompleted: 18, totalProjectHours: 500 },
    generalInfo: {
      mailingAddress: "team@atlasventures.io",
      phone: { countryCode: "+1", nationalNumber: "6467789900" },
      skype: "atlasventures.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2023-01-12",
      endDate: null,
    },
    account: { email: "team@atlasventures.io", role: "Client" },
    preferences: { language: "English", webNotif: true },
  },
  {
    id: "10",
    type: "client",
    companyName: "Lumen Technologies",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Lumen Technologies",
      firstName: "Lumen",
      lastName: "Client",
      email: "info@lumentech.net",
      role: "Client",
      avatar: "https://i.pravatar.cc/160?img=66",
    },
    metrics: { openProjects: 2, projectsCompleted: 11, totalProjectHours: 300 },
    generalInfo: {
      mailingAddress: "info@lumentech.net",
      phone: { countryCode: "+34", nationalNumber: "932445566" },
      skype: "lumentech.client",
      gender: "other",
    },
    jobInfo: {
      title: "Client",
      manager: "-",
      salaryPeriod: "-",
      startDate: "2024-10-05",
      endDate: null,
    },
    account: { email: "info@lumentech.net", role: "Client" },
    preferences: { language: "Spanish", webNotif: false },
  },
  {
    id: "11",
    type: "user",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Mert Can Aydın",
      firstName: "Mert Can",
      lastName: "Aydın",
      email: "mert.aydin@company.com",
      role: "Backend Developer",
      avatar: "https://i.pravatar.cc/160?img=33",
    },
    metrics: { openProjects: 2, projectsCompleted: 6, totalProjectHours: 350 },
    generalInfo: {
      mailingAddress: "mert.aydin@company.com",
      phone: { countryCode: "+90", nationalNumber: "5345556677" },
      skype: "mert.backend",
      dob: "1992-07-18",
      gender: "male",
    },
    jobInfo: {
      title: "Backend Developer",
      manager: "Barış Korkmaz",
      salaryPeriod: "Aylık",
      startDate: "2022-03-20",
      endDate: null,
    },
    account: { email: "mert.aydin@company.com", role: "Developer" },
    preferences: { language: "English", webNotif: true },
    leave: { remainingDays: 12 },
  },
  {
    id: "12",
    type: "user",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Selin Kaya",
      firstName: "Selin",
      lastName: "Kaya",
      email: "selin.kaya@company.com",
      role: "Marketing Specialist",
      avatar: "https://i.pravatar.cc/160?img=47",
    },
    metrics: { openProjects: 4, projectsCompleted: 10, totalProjectHours: 500 },
    generalInfo: {
      mailingAddress: "selin.kaya@company.com",
      phone: { countryCode: "+90", nationalNumber: "5556667788" },
      skype: "selin.marketing",
      dob: "1993-09-10",
      gender: "female",
    },
    jobInfo: {
      title: "Marketing Specialist",
      manager: "Derya Aksoy",
      salaryPeriod: "Aylık",
      startDate: "2021-11-01",
      endDate: null,
    },
    account: { email: "selin.kaya@company.com", role: "Marketing" },
    preferences: { language: "Turkish", webNotif: false },
    leave: { remainingDays: 9 },
  },
  {
    id: "13",
    type: "user",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Ahmet Karadeniz",
      firstName: "Ahmet",
      lastName: "Karadeniz",
      email: "ahmet.karadeniz@company.com",
      role: "QA Engineer",
      avatar: "https://i.pravatar.cc/160?img=52",
    },
    metrics: { openProjects: 3, projectsCompleted: 7, totalProjectHours: 390 },
    generalInfo: {
      mailingAddress: "ahmet.karadeniz@company.com",
      phone: { countryCode: "+90", nationalNumber: "5324445566" },
      skype: "ahmet.qa",
      dob: "1990-03-25",
      gender: "male",
    },
    jobInfo: {
      title: "QA Engineer",
      manager: "Mert Can Aydın",
      salaryPeriod: "Aylık",
      startDate: "2020-08-10",
      endDate: null,
    },
    account: { email: "ahmet.karadeniz@company.com", role: "QA" },
    preferences: { language: "English", webNotif: true },
    leave: { remainingDays: 7 },
  },
  {
    id: "14",
    type: "user",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Ceren Erdem",
      firstName: "Ceren",
      lastName: "Erdem",
      email: "ceren.erdem@company.com",
      role: "Finance Analyst",
      avatar: "https://i.pravatar.cc/160?img=56",
    },
    metrics: { openProjects: 1, projectsCompleted: 12, totalProjectHours: 280 },
    generalInfo: {
      mailingAddress: "ceren.erdem@company.com",
      phone: { countryCode: "+90", nationalNumber: "5317778899" },
      skype: "ceren.finance",
      dob: "1991-12-02",
      gender: "female",
    },
    jobInfo: {
      title: "Finance Analyst",
      manager: "Barış Korkmaz",
      salaryPeriod: "Aylık",
      startDate: "2019-06-15",
      endDate: null,
    },
    account: { email: "ceren.erdem@company.com", role: "Finance" },
    preferences: { language: "Turkish", webNotif: true },
    leave: { remainingDays: 11 },
  },
  {
    id: "15",
    type: "user",
    rightSlot: "ClientStats",
    bgColor: "#110e3f",
    overview: {
      name: "Emre Demir",
      firstName: "Emre",
      lastName: "Demir",
      email: "emre.demir@company.com",
      role: "Full Stack Developer",
      avatar: "https://i.pravatar.cc/160?img=26",
    },
    metrics: { openProjects: 5, projectsCompleted: 15, totalProjectHours: 720 },
    generalInfo: {
      mailingAddress: "emre.demir@company.com",
      phone: { countryCode: "+90", nationalNumber: "5348889900" },
      skype: "emre.fullstack",
      dob: "1996-01-30",
      gender: "male",
    },
    jobInfo: {
      title: "Full Stack Developer",
      manager: "Zehra Ecer",
      salaryPeriod: "Aylık",
      startDate: "2023-04-01",
      endDate: null,
    },
    account: { email: "emre.demir@company.com", role: "Developer" },
    preferences: { language: "English", webNotif: true },
    leave: { remainingDays: 13 },
  },
  {
    id: "16",
    type: "leads",
    companyName: "FutureTech",
    rightSlot: "LeadPipeline",
    bgColor: "#0abb87 ",
    overview: {
      name: "Melih Gençtürk",
      firstName: "FutureTech",
      lastName: "Lead",
      email: "contact@futuretech.io",
      role: "Lead",
      avatar: "https://i.pravatar.cc/160?img=68",
    },
    metrics: { openProjects: 0, projectsCompleted: 0, totalProjectHours: 0 },
    generalInfo: {
      mailingAddress: "contact@futuretech.io",
      phone: { countryCode: "+1", nationalNumber: "4159876543" },
      skype: "futuretech.lead",
      gender: "other",
    },
    jobInfo: {
      title: "Lead Prospect",
      manager: "Selin Kaya",
      salaryPeriod: "-",
      startDate: "2025-02-01",
      endDate: null,
    },
    account: { email: "contact@futuretech.io", role: "Lead" },
    preferences: { language: "English", webNotif: true },
  },
  {
    id: "17",
    type: "leads",
    companyName: "FutureTech",
    rightSlot: "LeadPipeline",
    bgColor: "#0abb87 ",
    overview: {
      name: "Doruk Günay",
      firstName: "BrightPath",
      lastName: "Lead",
      email: "info@brightpath.com",
      role: "Lead",
      avatar: "https://i.pravatar.cc/160?img=65",
    },
    metrics: { openProjects: 1, projectsCompleted: 0, totalProjectHours: 10 },
    generalInfo: {
      mailingAddress: "info@brightpath.com",
      phone: { countryCode: "+44", nationalNumber: "2087765544" },
      skype: "brightpath.lead",
      gender: "other",
    },
    jobInfo: {
      title: "Potential Client",
      manager: "Barış Korkmaz",
      salaryPeriod: "-",
      startDate: "2025-03-10",
      endDate: null,
    },
    account: { email: "info@brightpath.com", role: "Lead" },
    preferences: { language: "English", webNotif: false },
  },
  {
    id: "18",
    type: "leads",
    companyName: "BrightPath",
    rightSlot: "LeadPipeline",
    bgColor: "#0abb87 ",
    overview: {
      name: "Yunus Çankaya",
      firstName: "GreenEdge",
      lastName: "Lead",
      email: "sales@greenedge.com",
      role: "Lead",
      avatar: "https://i.pravatar.cc/160?img=66",
    },
    metrics: { openProjects: 0, projectsCompleted: 0, totalProjectHours: 0 },
    generalInfo: {
      mailingAddress: "sales@greenedge.com",
      phone: { countryCode: "+49", nationalNumber: "3011223344" },
      skype: "greenedge.lead",
      gender: "other",
    },
    jobInfo: {
      title: "Business Lead",
      manager: "Zehra Ecer",
      salaryPeriod: "-",
      startDate: "2025-04-05",
      endDate: null,
    },
    account: { email: "sales@greenedge.com", role: "Lead" },
    preferences: { language: "German", webNotif: true },
  },
];
